import type { JSX } from "react";
import { Container } from "../HtmlTags/Container/Container";
import "./AuthRouteFallback.css";

/** In-flow Suspense fallback for auth routes (avoids fixed PageLoader collapsing the outlet). */
export function AuthRouteFallback(): JSX.Element {
  return (
    <Container
      className="auth-route-fallback"
      data-testid="auth-route-fallback"
      aria-busy="true"
      aria-label="Loading"
    >
      <Container className="auth-route-fallback-spinner" decorativeContainer />
    </Container>
  );
}
